export default (() => {
    if (typeof self !== "undefined") {
        return self;
    }
    else if (typeof window !== "undefined") {
        return window;
    }
    else {
        return Function("return this")();
    }
})();



//////////////////
// WEBPACK FOOTER
// ./modules/socketapi/~/engine.io-client/build/esm/globalThis.browser.js
// module id = 218
// module chunks = 0